import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaUsers } from "react-icons/fa";
import { GrDocumentUser } from "react-icons/gr";
import { IoNotificationsSharp } from "react-icons/io5";

import './layout.css';

const AnnouncementLayout = ({ children }) => {
  return (
    <div style={{ marginTop: '60px' }}>
      <h2 className="announcement-subtitle">
        <IoNotificationsSharp /> All Announcements
      </h2>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
            <li className="nav-item">
              <NavLink
                id="emp-announcements-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/emp-announcements"
              >
                <GrDocumentUser className="nav-icon" /> Emp Announcements
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="dept-announcements-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/dept-announcements"
              >
                <FaUsers className="nav-icon" /> Dept Announcements
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="user-announcements-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/user-announcements"
              >
                <FaUsers className="nav-icon" /> User Announcements
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="content">
          {children}
        </div>
      </section>
    </div>
  );
};

export default AnnouncementLayout;
